import { useEffect } from 'react';
import Mixpanel from 'services/tracking';

export default function useScreenTracking(screen: string, properties = {}) {
  useEffect(() => {
    Mixpanel.track('Screen', { name: screen, ...properties });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
